var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExistingProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.991,
    height: 48.279,
    viewBox: "0 0 45.991 48.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#abddf5;}.b{fill:#27b7ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.625 -40.687)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.476,62.675H56.02a1.884,1.884,0,0,1-1.883-1.883V51.3a10.611,10.611,0,0,1,21.222,0v9.494A1.884,1.884,0,0,1,73.476,62.675ZM57.9,58.909H71.593V51.3a6.845,6.845,0,0,0-13.691,0Z",
    transform: "translate(0.873 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.616,88.024H42.625l6.522-34.912H82.094Z",
    transform: "translate(0 0.942)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.3,76.6a1.883,1.883,0,0,1-1.848-1.538L70.59,65.1a1.883,1.883,0,1,1,3.7-.691l1.86,9.956a1.882,1.882,0,0,1-1.506,2.2A1.818,1.818,0,0,1,74.3,76.6Z",
    transform: "translate(2.118 1.682)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingProduct);
export default __webpack_public_path__ + "static/media/existing_product.92b4531fe5d7d067917524831bb36834.svg";
export { ForwardRef as ReactComponent };